// extracted by mini-css-extract-plugin
export default {"preloader":"MainLayout_preloader__3h0Qe"};